
import { cloneDeep } from 'lodash'
import { defineComponent, PropType } from 'vue'
import TimeService from '../common/timeService'
import UserService from '../common/userService'
import UserAvailabilityByType from '../models/userAvailabilityByType'

export default defineComponent({
  name: 'AvailabilityForm',

  props: {
    /** The availability to view and edit */
    userAvailability: {
      type: Object as PropType<UserAvailabilityByType>,
      required: true
    },

    /** The Id of the user who owns the availability */
    userId: {
      type: Number,
      required: true
    }
  },

  emits: ['update-availability'],

  data () {
    return {
      /** Day enum values */
      // days: [1, 2, 4, 8, 16],
      days: ['M', 'T', 'W', 'TH', 'F'],

      /** Indicates that availability is being edited */
      editing: false,

      /** An copy of the availability to edit */
      editedAvailability: null as unknown as UserAvailabilityByType
    }
  },

  methods: {
    /**
     * Resets the edited availability and shows the form.
     */
    beginEditingAvailability () {
      console.log(this.userAvailability.availability)
      this.editedAvailability = cloneDeep(this.userAvailability)
      this.editing = true
    },

    /**
     * Returns a string for the given time represented as the number of minutes past the start of day
     * @param timeNumb: Number of minutes past the start of day
     */
    parseTime (timeNum: number): string | null {
      return TimeService.convertTimeToString(timeNum)
    },

    /**
     * Updates the edited availability
     */
    saveAvailability () {
      UserService.updateAvailability(this.userId, this.editedAvailability.availability).then(res => {
        this.$emit('update-availability', res.data.availability)
        this.editing = false
      })
    }
  }
})
